import client from './client';

const API_URL = '/api/standards';
const LESSONS_URL = '/api/lessons';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const fetchStandards = async (params) => {
    try {
        const response = await client.get(API_URL, { params, headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching standards:', error);
        throw error;
    }
};

export const fetchGradeLevels = async (subject) => {
    try {
        const params = subject ? { subject } : {};
        const response = await client.get(`${API_URL}/grades`, { params, headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching grade levels:', error);
        throw error;
    }
};

export const fetchDomains = async (grade, subject) => {
    try {
        const params = {};
        if (grade) params.grade = grade;
        if (subject) params.subject = subject;
        const response = await client.get(`${API_URL}/domains`, { params, headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching domains:', error);
        throw error;
    }
};

export const fetchSubjects = async () => {
    try {
        const response = await client.get(`${API_URL}/subjects`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching subjects:', error);
        throw error;
    }
};

export const fetchLessonStandards = async (lessonId) => {
    try {
        const response = await client.get(`${LESSONS_URL}/${lessonId}/standards`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error fetching lesson standards:', error);
        throw error;
    }
};

export const addLessonStandard = async (lessonId, data) => {
    try {
        const response = await client.post(`${LESSONS_URL}/${lessonId}/standards`, data, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error adding lesson standard:', error);
        throw error;
    }
};

export const removeLessonStandard = async (lessonId, standardId) => {
    try {
        const response = await client.delete(`${LESSONS_URL}/${lessonId}/standards/${standardId}`, { headers: getAuthHeaders() });
        return response.data;
    } catch (error) {
        console.error('Error removing lesson standard:', error);
        throw error;
    }
};
